import mainPage from "@/views/mainPage"

export default [
    {
        path: "/",
        redirect: "/common"
    },
    {
        path: "/mainPage",
        name: "mainPage",
        component: mainPage,
        children: [
              {
                path: "/common",
                name: "common",
                component: () => import(/* webpackChunkName: "common" */ "@/views/menuPage/CommonInfo.vue"),
            },
            {
                path: "/app",
                name: "app",
                component: () => import(/* webpackChunkName: "app" */ "@/views/menuPage/ManageApp.vue"),
            },
            {
                path: "/FileCert",
                name: "FileCert",
                component: () => import(/* webpackChunkName: "FileCert" */ "@/views/menuPage/ManageFileCert.vue"),
            },
            {
                path: "/DeactSysFunction",
                name: "DeactSysFunction",
                component: () => import(/* webpackChunkName: "DeactSysFunction" */ "@/views/menuPage/DeactSysFunction.vue"),
            },
            {
                path: "/SaveConfigScheme",
                name: "SaveConfigScheme",
                component: () => import(/* webpackChunkName: "SaveConfigScheme" */ "@/views/menuPage/SaveConfigScheme.vue"),
            },
            {
                path: "/CustomConfigMode",
                name: "CustomConfigMode",
                component: () => import(/* webpackChunkName: "CustomConfigMode" */ "@/views/menuPage/CustomConfigMode.vue"),
            },
            {
                path: "/CustomConfigModeChildPage",
                name: "CustomConfigModeChildPage",
                component: () => import(/* webpackChunkName: "SaveConfigScheme" */ "@/views/menuPage/CustomConfigPages/configPage.vue"),
            },
        ]
    },
]